import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';

import { StripeConnectSettings } from '../../../influencer/stripe-connect';

export const StripePaymentMethod: React.FC = () => (
  <div className="px-[30px] py-[40px] bg-white rounded-xl">
    <Typography variant="h5" className="mb-6 flex items-center">
      Payment methods
      {<StripeInfoTooltip />}
    </Typography>
    <StripeConnectSettings />
  </div>
);

const StripeInfoTooltip: React.FC = () => {
  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            background: '#EAECF0',
          },
        },
      }}
      title={
        <Typography variant="body1" className="text-[#101828]">
          For other payment method please contact our{' '}
          <a href="mailto:creatorsupport@playbookapp.io">support team</a>
        </Typography>
      }
    >
      <div>
        <IconButton>
          <InfoOutlinedIcon />
        </IconButton>
      </div>
    </Tooltip>
  );
};
